/* 2026-10-15 · Cesta lateral fiable (modelo Manifest)
   1. Quita secciones repetidas o vacías en las peticiones a la cesta (límite de Shopify: 5).
   2. Ebooks: si ya están en la cesta no se suman; se deja 1 unidad.
   3. Tras añadir: vuelve a pedir la cesta a Shopify, pinta artículos y total, quita «Tu cesta está vacía»
      y abre el panel lateral. No depende de que bundle.js termine sin errores.
   4. postMessage con origen explícito (compatibilidad con Safari antiguo).
   5. Ebook gratuito («Descargar»): directo a finalizar compra.
   Se carga después de verso-preventa.js y antes de bundle.js. */
(function () {
  if (!window.fetch || window.__versoCesta) return;
  window.__versoCesta = true;

  var origin = window.location.origin;
  var nativePost = window.postMessage.bind(window);
  window.postMessage = function (msg, target) {
    if (arguments.length < 2 || target === undefined) return nativePost(msg, origin);
    return nativePost.apply(null, arguments);
  };

  var originalFetch = window.fetch;

  function digitalButton(id) {
    return document.querySelector('add-to-cart[data-variant-id="' + id + '"][data-digital="true"]:not([data-reserve-state="preventa"]):not([data-selling-plan-id])');
  }

  function cleanSections(list) {
    if (!Array.isArray(list)) return list;
    return list.filter(function (s, i) { return s && list.indexOf(s) === i; });
  }

  function openDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer || drawer.getAttribute('data-open') === 'true') return;
    nativePost({ drawerId: 'cart-drawer', drawerAction: 'open', toggleId: 'cart-drawer-toggle' }, origin);
  }

  function swap(target, source, selector) {
    var a = target.querySelector(selector);
    var b = source.querySelector(selector);
    if (a && b) a.innerHTML = b.innerHTML;
  }

  function refreshDrawer() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return Promise.resolve();
    return originalFetch(window.location.pathname + '?sections=header,cart-icon', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || !data.header) return;
        var parser = new DOMParser();
        var fresh = parser.parseFromString(data.header, 'text/html').getElementById('cart-drawer');
        if (!fresh) return;
        swap(drawer, fresh, '.js-item-contents');
        swap(drawer, fresh, '.js-footer-contents');
        swap(drawer, fresh, 'cart-recommendations');
        var express = drawer.querySelector('.vl-cart-express');
        var freshExpress = fresh.querySelector('.vl-cart-express');
        if (express && freshExpress && !express.children.length) express.innerHTML = freshExpress.innerHTML;
        var empty = fresh.classList.contains('is-empty');
        [drawer, document.getElementById('cart-snippet'), document.getElementById('main-cart-footer')].forEach(function (el) {
          if (el) el.classList.toggle('is-empty', empty);
        });
        var toggle = document.getElementById('cart-drawer-toggle');
        if (toggle && data['cart-icon']) {
          var icon = parser.parseFromString(data['cart-icon'], 'text/html').querySelector('.shopify-section');
          if (icon) toggle.innerHTML = icon.innerHTML;
        }
      })
      .catch(function () {});
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
    var isCart = isAdd || /\/cart\/(change|update)(\.js)?(\?|$)/.test(url);
    var goCheckout = false;
    try {
      if (isCart && init && typeof init.body === 'string' && init.body.charAt(0) === '{') {
        var body = JSON.parse(init.body);
        if (body.sections) body.sections = cleanSections(body.sections);
        var button = isAdd && body.items && body.items.length === 1 && !body.items[0].selling_plan ? digitalButton(body.items[0].id) : null;
        if (button) {
          goCheckout = button.getAttribute('data-free') === 'true';
          var updates = {};
          updates[body.items[0].id] = 1;
          body = { updates: updates, sections: body.sections };
          input = ((window.routes && window.routes.cart_update_url) || '/cart/update') + '.js';
        }
        init = Object.assign({}, init, { body: JSON.stringify(body) });
      }
    } catch (e) {}
    var request = originalFetch.call(this, input, init);
    if (isAdd) {
      request.then(function (r) {
        if (!r || !r.ok) return;
        if (goCheckout) { window.location.href = '/checkout'; return; }
        refreshDrawer().then(openDrawer);
      }).catch(function () {});
    }
    return request;
  };
})();